import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SocialShare from '../components/SocialShare';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';
import './NewsDetailPage.css';

const fmtDate = d => d ? new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

// Render body — HTML from rich editor or plain text from old articles
function ArticleBody({ body }) {
    if (!body) return <p>For more information or inquiries, please contact us at <a href="mailto:mncwestv@gmail.com">mncwestv@gmail.com</a>.</p>;
    const isHtml = body.includes('<');
    if (isHtml) return <div className="news-details-content" dangerouslySetInnerHTML={{ __html: body }} />;
    return <div className="news-details-content">{body.split('\n').map((line, i) => <p key={i}>{line}</p>)}</div>;
}

const NewsDetailPage = () => {
    const { id } = useParams();
    const [site, setSite] = useState(null);
    const [newsItem, setNewsItem] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get('/content/site'),
            api.get(`/news/${id}`),
        ])
            .then(([siteRes, newsRes]) => {
                setSite(siteRes.data);
                setNewsItem(newsRes.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error loading news item:', error);
                setLoading(false);
            });
    }, [id]);

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!newsItem) {
        return (
            <div className="error-screen">
                <h1>News item not found</h1>
                <Link to="/news" className="btn btn-primary">Back to News</Link>
            </div>
        );
    }

    const pageUrl = `${window.location.origin}/news/${id}`;

    return (
        <div className="App">
            <MetaTags
                title={`${newsItem.title} - Melbourne Nepalese Community West`}
                description={newsItem.excerpt}
                url={pageUrl}
                image={newsItem.image_url}
                type="article"
            />

            <Header data={site} />
            <div className="news-detail-container">
                <div className="container">
                    <Link to="/news" className="back-link">
                        <i className="fas fa-arrow-left"></i> Back to News
                    </Link>

                    <article className="news-detail">
                        <div className="news-detail-header">
                            <span className="news-label">
                                {newsItem.category}
                            </span>
                            <h1>{newsItem.title}</h1>
                            <div className="news-meta">
                                <span className="news-date">
                                    <i className="fas fa-calendar-alt"></i>
                                    {fmtDate(newsItem.published_at)}
                                </span>
                            </div>
                        </div>

                        {newsItem.image_url && (
                            <div className="news-detail-image">
                                <img src={newsItem.image_url} alt={newsItem.title} />
                            </div>
                        )}

                        <div className="news-detail-content">
                            <SocialShare
                                url={pageUrl}
                                title={newsItem.title}
                                description={newsItem.excerpt}
                            />

                            {newsItem.excerpt && <p className="news-summary">{newsItem.excerpt}</p>}

                            <div className="news-body">
                                <ArticleBody body={newsItem.body} />
                            </div>
                        </div>

                        <div className="news-detail-footer">
                            <Link to="/news" className="btn btn-outline">
                                <i className="fas fa-arrow-left"></i> Back to All News
                            </Link>
                        </div>
                    </article>
                </div>
            </div>
            <Footer data={site} />
        </div>
    );
};

export default NewsDetailPage;
